import { IJOIST_INPUT_TYPE } from '../../../../../utils/constants'
import { createGenericSlice } from '../../../../../utils/slices'
import { JOIST_MEMBER_TYPE } from '../../../common/constants'

export const trussSlice = createGenericSlice({
  name: 'truss',
  initialState: {
    type: JOIST_MEMBER_TYPE.TRUSS,
    ijoistInputType: IJOIST_INPUT_TYPE.MANUFACTURER,
    material: 5,
    width: 1.5,
    depth: 5.5,
    ply: 1,
    memberID: 'Truss 1',
    load: 0,
    uplift: 0,
  },
})

export const trussActions = trussSlice.actions
